module.exports = __webpack_public_path__ + "img/bg2.bc541678.png";